import { Component, OnInit, Input } from '@angular/core';
import { ManagedClient } from 'app/shared/models/managed-client';
import { AlertService } from 'app/shared/services/alert.service';
import { AuthService } from 'app/login/services/auth.service';
import { User } from 'app/shared/models/user';
import { DacConfig } from 'app/shared/services/dac-config.service';
import { ClientService } from 'app/shared/services/client.service';
import { MessageTemplateService } from 'app/admin/services/message-template.service';

@Component({
  selector: 'dac-client-send-invitation',
  templateUrl: './client-send-invitation.component.html',
  styleUrls: ['./client-send-invitation.component.scss']
})
export class ClientSendInvitationComponent implements OnInit {

  @Input() client:ManagedClient;
  private user:User;
  public confirmEmail:boolean;
  public toEmailAddress:string;
  public emailSubject:string;
  public emailMessage:string;
  public fromEmailAddress:string;
  public replyToEmailAddress:string;
  public testEmailAddress:string;
  
  constructor(private alertService:AlertService, private authService:AuthService, 
    private dacConfig:DacConfig, private clientService:ClientService, private messageTemplateService:MessageTemplateService) {

      this.emailSubject = "Loading...";
      this.emailMessage = "Loading...";


    // let originalSubject =  "Discover and Change - Assessment Portal Information";
    // this.emailSubject = originalSubject;
    // this.authService.getCurrentUser().then(user => {
    //   this.user = user;
    //   if (this.emailSubject == originalSubject && this.user.companyName) {
    //     this.emailSubject = "Assessment Portal Information - " + this.user.companyName;
    //   }

    //   this.setupEmailMessage();
    // });
    this.confirmEmail = false;
  }

  ngOnInit() {
    if (!this.client) {
      this.failMessageTemplateLoad(new Error("No client set for this invitation"));
    }
    this.toEmailAddress = this.client.email;

    this.messageTemplateService.getMessageForClient(this.client).then(msgTemplate => {
      if (msgTemplate.subject) {
        this.emailSubject = msgTemplate.subject;
      } else {
        this.emailSubject = "";
      }

      if (msgTemplate.message) {
        this.emailMessage = msgTemplate.message;
      } else {
        this.emailMessage = "";
      }

      if (msgTemplate.replyTo) {
        this.replyToEmailAddress = msgTemplate.replyTo;
      }

      if (msgTemplate.testEmail) {
        this.testEmailAddress = msgTemplate.testEmail;
      }
      if (msgTemplate.to) {
        this.toEmailAddress = msgTemplate.to;
      }
      if (msgTemplate.from) {
        this.fromEmailAddress = msgTemplate.from;
      }
    })
    .catch(error => {
      this.failMessageTemplateLoad(error);
    });
  }

  private failMessageTemplateLoad(error) {
    console.error(error);
      this.alertService.error("We failed to retrieve the email template from the server.  Check your internet connection and try to refresh the page.");
      this.emailMessage = "Server Error - Failed to load";
      this.emailSubject = "Server Error - Failed to load";
  }

  public get supportEmail() {
    return this.dacConfig.supportEmail;
  }

  public get sender() {
    return this.user ? this.user.username : this.dacConfig.supportEmail;
  }

//   private setupEmailMessage() {
//     let message = `Hi ${this.client.getDisplayString()},

// I've created a unique code for you to use to take your assessments.
// The identifier you'll use to login is: ${this.client.customField1}

// You can take your assessments here: ${this.siteURL}`;
//     this.emailMessage = message;
//   }

  get companyName() {
    if (this.user) {
      return this.user.companyName;
    }
    return "";
  }

  get userEmail() {
    if (this.user) {
      return this.user.username;
    }
    return "";
  }

  get siteURL() {
    return this.dacConfig.take_test_url;
  }
  
  sendEmail() : void {
    this.confirmEmail = true;
  }

  confirmEmailSend() : void {
    this.sendEmailToServer(false);
  }

  sendTestEmail() : void {
    this.sendEmailToServer(true);
  }

  private sendEmailToServer(isTest:boolean) {
    if (!this.emailSubject || !this.emailSubject.trim()) {
      this.alertService.error("Email subject must not be empty");
    }
    if (!this.emailMessage || !this.emailMessage.trim()) {
      this.alertService.error("Email message must not be empty");
    }

    this.clientService.sendClientEmail(this.client.id, this.emailSubject, this.emailMessage, isTest)
    .then(() => {
      this.alertService.success("Email sent!");
      this.confirmEmail = false;
    })
    .catch(() => {
      this.alertService.error("The email failed to send. Check your connection and try again.  Or contact support");
    })
  }

  copyText() : void {
    try {
      var copyTextarea = document.getElementById('clientEmailTemplate') as HTMLInputElement;
      copyTextarea.select();
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      this.alertService.success("Message Copied To Clipboard!");
    } catch (err) {
      this.alertService.error("Uh Oh! Looks like your browser doesn't support this feature.  Highlight the text and press Ctrl+C or CMD+C", 5000);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/client-send-invitation/client-send-invitation.component.ts